import { clamp, getBounds, getIntersects  } from '@/util/bounds';

export const HORIZONTAL = Symbol('HORIZONTAL');
export const VERTICAL = Symbol('VERTICAL');
export const POSITION = Symbol('POSITION');
export const DIMENSION = Symbol('DIMENSION');
export const GUTTER = Symbol('GUTTER');

export const maxSnapDistancePixels = 10;
export const gutterSearchExpansion = maxSnapDistancePixels * 5;
export const includeGutterAlignments = false; // true;

const ZERO_THRESHOLD = 0.0001;


/*
alignment data format

axis: h/v
source: sourceId,
sourcePos: 0 min, 0.5 center, 1 max
target: targetId
targetPos: 0 min, 0.5 center, 1 max


greedy list of objects on screen
sort edges by position along axis
return alignment pair separated by min distance
*/

export const getAlignments = function (media, source, bounds, zoomFactor, isResizing) {

    // console.log('resizing?', isResizing);

    const snapDist = maxSnapDistancePixels / zoomFactor;

    const targets = getIntersects(media, bounds);

    let alignments = [];

    let minAbsoluteHorizontalDist = Number.POSITIVE_INFINITY;
    let minAbsoluteVerticalDist = Number.POSITIVE_INFINITY;

    let sourcePos,
        targetPos,
        crossAxisPos,
        crossAxisMin,
        crossAxisMax;

    const sourceItems = media.filter((media_item) => {
        return media_item.id === source[0];
    })

    if (sourceItems.length == 0) {
        return [];
    }

    const sourceItem = sourceItems[0];

    const targetItems = media.filter((media_item) => {
        return targets.indexOf(media_item.id) !== -1
    })


    let horizontalAlignments = [];
    let verticalAlignments = [];


    if (!isResizing) {
        // FIND MINIMUM DISTANCE BETWEEN 
        // ***** EDGE POSITIONS *****

        let a,b,c,d,e;
    
        const setAsActiveHorizontalGuideIfShorterDistance = (target, sourcePosIndex, targetPosIndex) => {
            c = Math.abs(a - b);
            if (c < minAbsoluteHorizontalDist || 
                (Math.abs(minAbsoluteHorizontalDist-c) <= ZERO_THRESHOLD && 
                    (
                        // the distance is the same, but there's a closer alignment on that same "row"
                        d - e < crossAxisMax - crossAxisMin ||
    
                        // the distance is the same, but this is a center/center align which is preferred 
                        (sourcePosIndex == .5 && targetPosIndex ==.5)
                    )
                )
            ) {
    
                // if (minAbsoluteHorizontalDist-c < ZERO_THRESHOLD) {
                //     console.log (target, minAbsoluteHorizontalDist-c, 
                //         (d - e < crossAxisMax - crossAxisMin),
                //         sourcePosIndex, targetPosIndex)
                // }
    
                minAbsoluteHorizontalDist = c;
                sourcePos = a;
                targetPos = b;
                crossAxisMin = e;
                crossAxisMax = d;
                crossAxisPos = sourceItem.y + (sourceItem.height / 2);
    
                // if (false &&
                //     horizontalAlignments.length > 0 &&
                //     horizontalAlignments[0].target == target ) {
    
                //     } else {
    
                horizontalAlignments = [{
                    axis: HORIZONTAL,
                    type: POSITION,
                    source: sourceItem,
                    target,
                    // sourcePosIndex, 
                    // targetPosIndex,
                    sourcePos,
                    targetPos,
                    crossAxisPos,
                    crossAxisMin,
                    crossAxisMax
                }]
    
                // }
    
    
            }
        }
    
        const setAsActiveVerticalGuideIfShorterDistance = (target, sourcePosIndex, targetPosIndex) => {
            c = Math.abs(a - b);
            if (c < minAbsoluteVerticalDist || 
                (Math.abs(minAbsoluteVerticalDist-c) <= ZERO_THRESHOLD && 
                    (
                        // the distance is the same, but there's a closer alignment on that same "column"
                        d - e < crossAxisMax - crossAxisMin ||
    
                        // the distance is the same, but this is a center/center align which is preferred 
                        (sourcePosIndex == .5 && targetPosIndex ==.5)
                    )
                )
            ) {
                minAbsoluteVerticalDist = c;
                sourcePos = a;
                targetPos = b;
                crossAxisMin = e;
                crossAxisMax = d;
                crossAxisPos = sourceItem.x + (sourceItem.width / 2);
    
                
                verticalAlignments = [{
                    axis: VERTICAL,
                    type: POSITION,
                    source: sourceItem,
                    target,
                    // sourcePosIndex, 
                    // targetPosIndex,
                    sourcePos,
                    targetPos,
                    crossAxisPos,
                    crossAxisMin,
                    crossAxisMax
                }]
            }
        }
        
        targetItems.map((item) => {

            if (!item || !sourceItem || item.id == sourceItem.id) {
                return;
            }
    
    
            // HORIZONTAL combinations
                // sourceMin targetMin
                a = sourceItem.x;
                b = item.x;
                d = Math.max(sourceItem.y + sourceItem.height, item.y + item.height);
                e = Math.min(sourceItem.y, item.y);
                setAsActiveHorizontalGuideIfShorterDistance(item, 0, 0);
    
                // sourceMin targetMax
                // a = sourceItem.x;
                b = item.x + item.width;
                // d = Math.max(sourceItem.y + sourceItem.height, item.y + item.height);
                // e = Math.min(sourceItem.y, item.y);
                setAsActiveHorizontalGuideIfShorterDistance(item, 0, 1);
    
                // sourceMin targetCenter
                // a = sourceItem.x;
                b = item.x + item.width/2;
                // d = Math.max(sourceItem.y + sourceItem.height, item.y + item.height);
                // e = Math.min(sourceItem.y, item.y);
                setAsActiveHorizontalGuideIfShorterDistance(item, 0, .5);
    
    
                // sourceMax targetMin
                a = sourceItem.x + sourceItem.width;
                b = item.x;
                setAsActiveHorizontalGuideIfShorterDistance(item, 1, 0);
    
                // sourceMax targetMax
                // a = sourceItem.x + sourceItem.width;
                b = item.x + item.width;
                setAsActiveHorizontalGuideIfShorterDistance(item, 1, 1);
    
                // sourceMax targetCenter
                // a = sourceItem.x + sourceItem.width;
                b = item.x + item.width/2;
                setAsActiveHorizontalGuideIfShorterDistance(item, 1, .5);
    
    
                // sourceCenter targetMin
                a = sourceItem.x + sourceItem.width/2;
                b = item.x;
                setAsActiveHorizontalGuideIfShorterDistance(item, .5, 0);
    
                // sourceCenter targetMax
                // a = sourceItem.x + sourceItem.width/2;
                b = item.x + item.width;
                setAsActiveHorizontalGuideIfShorterDistance(item, .5, 1);
    
                // sourceCenter targetCenter
                // a = sourceItem.x + sourceItem.width/2;
                b = item.x + item.width/2;
                setAsActiveHorizontalGuideIfShorterDistance(item, .5, .5);
    
    
            // VERTICAL combinations
                // sourceMin targetMin
                a = sourceItem.y;
                b = item.y;
                d = Math.max(sourceItem.x + sourceItem.width, item.x + item.width);
                e = Math.min(sourceItem.x, item.x);
                setAsActiveVerticalGuideIfShorterDistance(item, 0, 0);
    
                // sourceMin targetMax
                b = item.y + item.height;
                setAsActiveVerticalGuideIfShorterDistance(item, 0, 1);
    
                // sourceMin targetCenter
                b = item.y + item.height/2;
                setAsActiveVerticalGuideIfShorterDistance(item, 0, .5);
    
    
                // sourceMax targetMin
                a = sourceItem.y + sourceItem.height;
                b = item.y;
                setAsActiveVerticalGuideIfShorterDistance(item, 1, 0);
    
                // sourceMax targetMax
                b = item.y + item.height;
                setAsActiveVerticalGuideIfShorterDistance(item, 1, 1);
    
                // sourceMax targetCenter
                b = item.y + item.height/2;
                setAsActiveVerticalGuideIfShorterDistance(item, 1, .5);
    
    
                // sourceCenter targetMin
                a = sourceItem.y + sourceItem.height/2;
                b = item.y;
                setAsActiveVerticalGuideIfShorterDistance(item, .5, 0);
    
                // sourceCenter targetMax
                b = item.y + item.height;
                setAsActiveVerticalGuideIfShorterDistance(item, .5, 1);
    
                // sourceCenter targetCenter
                b = item.y + item.height/2;
                setAsActiveVerticalGuideIfShorterDistance(item, .5, .5);
            
        });
    
    
        if (minAbsoluteHorizontalDist < Number.POSITIVE_INFINITY) {
            alignments = alignments.concat(horizontalAlignments);
        }
    
        if (minAbsoluteVerticalDist < Number.POSITIVE_INFINITY) {
            alignments = alignments.concat(verticalAlignments);
        }


    } else {

        // alignment args: media, source, bounds, zoomFactor, isResizing

        // FIND MINIMUM DISTANCE BETWEEN
        // ##### EDGE LENGTHS ####

        let closestMatchingWidth = Number.POSITIVE_INFINITY;
        let closestMatchingHeight = Number.POSITIVE_INFINITY;

        const getWidthAlignment = (target, source, targetDim, sourceDim) => {

            return {
                axis: HORIZONTAL,
                type: DIMENSION,
                source,
                target,
                // sourcePosIndex, 
                // targetPosIndex,
                sourceDim,
                targetDim
            }
        }

        const getHeightAlignment = (target, source, targetDim, sourceDim) => {

            return {
                axis: VERTICAL,
                type: DIMENSION,
                source,
                target,
                // sourcePosIndex, 
                // targetPosIndex,
                sourceDim,
                targetDim
            }
        }

        
        targetItems.map((item, i, len) => {
            //  console.log(item, i, len)
    
            if (!item || !sourceItem || item == sourceItem) {
                return;
            }
    
            // HORIZONTAL
            let deltaW = Math.abs(item.width - sourceItem.width);
            if (deltaW < minAbsoluteHorizontalDist) {
                closestMatchingWidth = item.width;
                minAbsoluteHorizontalDist = deltaW;
                let widthAlignment = getWidthAlignment(item, sourceItem, item.width, sourceItem.width)
                horizontalAlignments = [widthAlignment]
            } else if (Math.abs(item.width - closestMatchingWidth) <= ZERO_THRESHOLD) {

                let widthAlignment = getWidthAlignment(item, sourceItem, item.width, sourceItem.width)
                horizontalAlignments.push(widthAlignment);
            }


            // VERTICAL
            let deltaH = Math.abs(item.height - sourceItem.height);
            if (deltaH < minAbsoluteVerticalDist) {
                closestMatchingHeight = item.height;
                minAbsoluteVerticalDist = deltaH
                let heightAlignment = getHeightAlignment(item, sourceItem, item.height, sourceItem.height);
                verticalAlignments = [heightAlignment]
            } else if (Math.abs(item.height - closestMatchingHeight) <= ZERO_THRESHOLD) {

                let heightAlignment = getHeightAlignment(item, sourceItem, item.height, sourceItem.height);
                verticalAlignments.push(heightAlignment);
            }
            
        });

        if (minAbsoluteHorizontalDist < Number.POSITIVE_INFINITY) {
            alignments = alignments.concat(horizontalAlignments);
        }
    
        if (minAbsoluteVerticalDist < Number.POSITIVE_INFINITY) {
            alignments = alignments.concat(verticalAlignments);
        }

        // console.log(horizontalAlignments, verticalAlignments)
    }


    if (includeGutterAlignments) {


        const getGutterWidthAlignment = (source, targetGutter, sourceGutter) => {
            let target = (targetGutter.itemA !== source) ? targetGutter.itemA : (
                (targetGutter.itemB !== source) ? targetGutter.itemB : null
            )

            // console.log('src gut', sourceGutter.itemA.id, sourceGutter.itemB.id);

            return {
                axis: HORIZONTAL,
                type: GUTTER,
                source,
                // target,
                sourceGutter,
                targetGutter
            }
        }
        const getGutterHeightAlignment = (source, targetGutter, sourceGutter) => {
            let target = (targetGutter.itemA !== source) ? targetGutter.itemA : (
                (targetGutter.itemB !== source) ? targetGutter.itemB : null
            )
            return {
                axis: VERTICAL,
                type: GUTTER,
                source,
                // target,
                sourceGutter,
                targetGutter
            }
        }



        // FIND MINIMUM DISTANCE BETWEEN OBJECTS aka
        // ***** GUTTERS *****

        // HORIZONTAL
        // find all the onscreen objects which intersect the rectangle defined by the source object's vertical range
        const candidateHorizontalGutterBounds = {
            minX: bounds.minX,
            minY: sourceItem.y - gutterSearchExpansion,
            maxX: bounds.maxX,
            maxY: sourceItem.y + sourceItem.height + gutterSearchExpansion
        }

        const candidateHorizontalGutterTargetIds = getIntersects(media, candidateHorizontalGutterBounds);

        const candidateHorizontalGutterTargets = media.filter((media_item) => {
            return candidateHorizontalGutterTargetIds.indexOf(media_item.id) !== -1
        })

        /*
            for each of these
            find the distance from the max edge to every other object's min edge
            (positive values only)
        */

        const sourceLeftOfGutterContainingKeys = [];
        const targetLeftOfGutterContainingKeys = [];
        const sourceRightOfGutterContainingKeys = [];
        const targetRightOfGutterContainingKeys = [];
        const horizontalGutterDimentions = [];

        candidateHorizontalGutterTargets.map((itemA, i, allItems) => {
            candidateHorizontalGutterTargets.map((itemB, j) => {

                if (itemA.id == itemB.id) {
                    return;
                }

                // itemA is to the left of itemB

                var gutterDist = itemB.x - (itemA.x + itemA.width);

                if (gutterDist > 0) {
 
                    let key = itemA.id + '_' + itemB.id;

                    let hGutter = {
                        itemA,
                        itemB,
                        gutter: gutterDist
                    }
                    horizontalGutterDimentions[key] = hGutter

                }
            });
        });




        /*
            compare the gutter dimensions ONLY from pairings containing the sourceItem (set 1),
            to those pairings NOT CONTAINING the sourceItem IN THE SAME POSITION (left/right) (set 2).
                eg don't want to compare a FOO -> XXX gutter with a FOO -> YYY gutter
            Choose the target gutter measurement from the 2nd set (a)
            within snap distance of the measurement in the 1st set (b).
            Use the smallest delta: abs(a-b)
        */


        let horizontalGutterAlignments = [];
        let closestMatchingWidth = Number.POSITIVE_INFINITY;
        let minAbsoluteHorizontalGutterDist = Number.POSITIVE_INFINITY;

        const compareHorizontalGutters = (sourceGutter, targetGutter) => {
            if (
                sourceGutter == targetGutter
            ) {
                return;
            }
            
            if (
                (sourceGutter.itemA.id == sourceItem.id 
                && 
                targetGutter.itemA.id == sourceItem.id )
                    ||
                (sourceGutter.itemB.id == sourceItem.id 
                && 
                targetGutter.itemB.id == sourceItem.id)
            ) {
                return;
            }




            let deltaW = Math.abs(sourceGutter.gutter - targetGutter.gutter);

            // console.log('--', deltaW, targetGutter.itemA.id, targetGutter.itemB.id, sourceGutter.itemA.id, sourceGutter.itemB.id);

            if (deltaW <= snapDist) {
                if (
                    deltaW < minAbsoluteHorizontalGutterDist    &&
                    Math.abs(deltaW - minAbsoluteHorizontalGutterDist) > ZERO_THRESHOLD
                ) {
                    // console.log('sane?', deltaW, 'v', minAbsoluteHorizontalGutterDist)
                    //console.log('A', deltaW);//, targetGutter.itemA.id, targetGutter.itemB.id, sourceGutter.itemA.id, sourceGutter.itemB.id);
                    closestMatchingWidth = targetGutter.gutter;
                    minAbsoluteHorizontalGutterDist = deltaW;
                    let widthAlignment = getGutterWidthAlignment(sourceItem, targetGutter, sourceGutter)
                    horizontalGutterAlignments = [widthAlignment]
                } else if (Math.abs(deltaW - minAbsoluteHorizontalGutterDist) <= ZERO_THRESHOLD) {
                    //console.log('B', deltaW);
                    let widthAlignment = getGutterWidthAlignment(sourceItem, targetGutter, sourceGutter)
                    horizontalGutterAlignments.push(widthAlignment);
                }
                // console.log('deltaW', deltaW, 'v snapDist', snapDist);
            }
        }



        for (let i in horizontalGutterDimentions) {

            const sourceGutter = horizontalGutterDimentions[i];

            // check that it's in fact a ** source **
            if (sourceGutter.itemA.id == sourceItem.id 
                || 
                sourceGutter.itemB.id == sourceItem.id)
            {
                for (let j in horizontalGutterDimentions) {
                    const targetGutter = horizontalGutterDimentions[j];
                    // console.log("*", i, j);//sourceGutter, targetGutter)
                    // if (targetGutter.itemA ==)
    
                    compareHorizontalGutters(sourceGutter, targetGutter);
                }
            }


        }
        // console.log('len', lenA, lenB, sourceItem.id)




       
        


        // console.log(horizontalGutterAlignments.length)

        /*
            At this point there may be multiple alignment possibilities with the same snap distance
            Break ties using the smallest target gutter width
            There may still be more than one!
        */
        let minWidth = Number.POSITIVE_INFINITY;
        // console.log('-- --')
        horizontalGutterAlignments.map((hAlignment) => {
            // console.log(hAlignment.targetGutter.gutter, 'vs', minWidth)
            if (hAlignment.targetGutter.gutter < minWidth) {
                minWidth = hAlignment.targetGutter.gutter;
            }
        });
        // console.log('fin', minWidth);

        horizontalGutterAlignments = horizontalGutterAlignments.filter((hAlignment) => {
            if (hAlignment.targetGutter.gutter == minWidth) {
                return true;
            }
        });



 // remove any target gutter that's fully enclosed by another

 for (let len2=horizontalGutterAlignments.length, j=len2-1; j>=0; j--) {
    let alignment2 = horizontalGutterAlignments[j];
    let hGutter2 = alignment2.targetGutter;

    if (hGutter2) {

        let itemA2 = hGutter2.itemA;
        let itemB2 = hGutter2.itemB;
        // console.log(j, itemA2.id, itemB2.id)

        // console.log('horizontalGutterAlignments', horizontalGutterAlignments);

        for (let len1=horizontalGutterAlignments.length, i=len1-1; i>=0; i--) {
            let alignment1 = horizontalGutterAlignments[i];
            const hGutter1 = alignment1.targetGutter;
            // console.log('hGutter', i)

            if (hGutter1 && hGutter2 && hGutter1 !== hGutter2) {
                let itemA1 = hGutter1.itemA;
                let itemB1 = hGutter1.itemB;
    
                if (itemA1.x + itemA1.width <= itemA2.x + itemA2.width 
                    && itemB1.x >= itemB2.x
                    && itemA1.y + itemA1.height <= itemA2.y + itemA2.height 
                    && itemB1.y >= itemB2.y
                ) {


                    let k = horizontalGutterAlignments.indexOf(alignment2);
                    if (k !== -1) {
                        // horizontalGutterAlignments[k] = undefined;
                        // delete(horizontalGutterAlignments[k]);
                        horizontalGutterAlignments.splice(k, 1)
                        // console.log('XXX', hGutter2.itemA.id, hGutter2.itemB.id, '@', k, 'bc', hGutter1.itemA.id, hGutter1.itemB.id);
                        hGutter2 = undefined;
                        if (k < j) {
                            j++
                        }
                    }
                    

                    // delete(candidateHorizontalGutters[j]);// = null;
                }
            }
        }
    }
    // console.log(itemA2.id, itemB2.id)
}




        // console.log('horizontalGutterAlignments len', horizontalGutterAlignments.length, 'src', sourceItem.id);
        // if ( horizontalGutterAlignments.length < 4) {
        //     console.log('horizontalGutterAlignments', horizontalGutterAlignments);
        // }
            
        if (minAbsoluteHorizontalGutterDist < Number.POSITIVE_INFINITY) {
            alignments = alignments.concat(horizontalGutterAlignments);
        }
    


        /*
        *************************************
        */


        // VERTICAL
        // find all the onscreen objects which intersect the rectangle defined by the source object's vertical range
        const candidateVerticalGutterBounds = {
            minX: sourceItem.x - gutterSearchExpansion,
            minY: bounds.minY,
            maxX: sourceItem.x + sourceItem.width + gutterSearchExpansion,
            maxY: bounds.maxY
        }

        const candidateVerticalGutterTargetIds = getIntersects(media, candidateVerticalGutterBounds);

        const candidateVerticalGutterTargets = media.filter((media_item) => {
            return candidateVerticalGutterTargetIds.indexOf(media_item.id) !== -1
        })

        /*
            for each of these
            find the distance from the max edge to every other object's min edge
            (positive values only)
        */

        const sourceTopOfGutterContainingKeys = [];
        const targetTopOfGutterContainingKeys = [];
        const sourceBottomOfGutterContainingKeys = [];
        const targetBottomOfGutterContainingKeys = [];
        const verticalGutterDimentions = [];

        candidateVerticalGutterTargets.map((itemA, i, allItems) => {
            candidateVerticalGutterTargets.map((itemB, j) => {

                if (itemA.id == itemB.id) {
                    return;
                }

                // itemA is to the left of itemB

                var gutterDist = itemB.y - (itemA.y + itemA.height);

                if (gutterDist > 0) {
 
                    let key = itemA.id + '_' + itemB.id;

                    let hGutter = {
                        itemA,
                        itemB,
                        gutter: gutterDist
                    }
                    verticalGutterDimentions[key] = hGutter

                }
            });
        });




        /*
            compare the gutter dimensions ONLY from pairings containing the sourceItem (set 1),
            to those pairings NOT CONTAINING the sourceItem IN THE SAME POSITION (left/right) (set 2).
                eg don't want to compare a FOO -> XXX gutter with a FOO -> YYY gutter
            Choose the target gutter measurement from the 2nd set (a)
            within snap distance of the measurement in the 1st set (b).
            Use the smallest delta: abs(a-b)
        */


        let verticalGutterAlignments = [];
        let closestMatchingHeight = Number.POSITIVE_INFINITY;
        let minAbsoluteVerticalGutterDist = Number.POSITIVE_INFINITY;

        const compareVerticalGutters = (sourceGutter, targetGutter) => {
            if (
                sourceGutter == targetGutter
            ) {
                return;
            }
            
            if (
                (sourceGutter.itemA.id == sourceItem.id 
                && 
                targetGutter.itemA.id == sourceItem.id )
                    ||
                (sourceGutter.itemB.id == sourceItem.id 
                && 
                targetGutter.itemB.id == sourceItem.id)
            ) {
                return;
            }


            let deltaH = Math.abs(sourceGutter.gutter - targetGutter.gutter);

            // console.log('--', deltaH, targetGutter.itemA.id, targetGutter.itemB.id, sourceGutter.itemA.id, sourceGutter.itemB.id);

            if (deltaH <= snapDist) {
                if (
                    deltaH < minAbsoluteVerticalGutterDist    &&
                    Math.abs(deltaH - minAbsoluteVerticalGutterDist) > ZERO_THRESHOLD
                ) {
                    // console.log('sane?', deltaH, 'v', minAbsoluteVerticalGutterDist)
                    //console.log('A', deltaH);//, targetGutter.itemA.id, targetGutter.itemB.id, sourceGutter.itemA.id, sourceGutter.itemB.id);
                    closestMatchingHeight = targetGutter.gutter;
                    minAbsoluteVerticalGutterDist = deltaH;
                    let heightAlignment = getGutterHeightAlignment(sourceItem, targetGutter, sourceGutter)
                    verticalGutterAlignments = [heightAlignment]
                } else if (Math.abs(deltaH - minAbsoluteVerticalGutterDist) <= ZERO_THRESHOLD) {
                    //console.log('B', deltaH);
                    let heightAlignment = getGutterHeightAlignment(sourceItem, targetGutter, sourceGutter)
                    verticalGutterAlignments.push(heightAlignment);
                }
                // console.log('deltaH', deltaH, 'v snapDist', snapDist);
            }
        }



        for (let i in verticalGutterDimentions) {

            const sourceGutter = verticalGutterDimentions[i];

            // check that it's in fact a ** source **
            if (sourceGutter.itemA.id == sourceItem.id 
                || 
                sourceGutter.itemB.id == sourceItem.id)
            {
                for (let j in verticalGutterDimentions) {
                    const targetGutter = verticalGutterDimentions[j];
                    // console.log("*", i, j);//sourceGutter, targetGutter)
                    // if (targetGutter.itemA ==)
    
                    compareVerticalGutters(sourceGutter, targetGutter);
                }
            }


        }
        // console.log('len', lenA, lenB, sourceItem.id)




       
        


        // console.log(verticalGutterAlignments.length)

        /*
            At this point there may be multiple alignment possibilities with the same snap distance
            Break ties using the smallest target gutter width
            There may still be more than one!
        */
        let minHeight = Number.POSITIVE_INFINITY;
        // console.log('-- --')
        verticalGutterAlignments.map((vAlignment) => {
            // console.log(vAlignment.targetGutter.gutter, 'vs', minHeight)
            if (vAlignment.targetGutter.gutter < minHeight) {
                minHeight = vAlignment.targetGutter.gutter;
            }
        });
        // console.log('fin', minHeight);

        verticalGutterAlignments = verticalGutterAlignments.filter((vAlignment) => {
            if (vAlignment.targetGutter.gutter == minHeight) {
                return true;
            }
        });



        // remove any target gutter that's fully enclosed by another

        for (let len2=verticalGutterAlignments.length, j=len2-1; j>=0; j--) {
            let alignment2 = verticalGutterAlignments[j];
            let vGutter2 = alignment2.targetGutter;

            if (vGutter2) {

                let itemA2 = vGutter2.itemA;
                let itemB2 = vGutter2.itemB;
                // console.log(j, itemA2.id, itemB2.id)

                // console.log('verticalGutterAlignments', verticalGutterAlignments);

                for (let len1=verticalGutterAlignments.length, i=len1-1; i>=0; i--) {
                    let alignment1 = verticalGutterAlignments[i];
                    const vGutter1 = alignment1.targetGutter;
                    // console.log('hGutter', i)

                    if (vGutter1 && vGutter2 && vGutter1 !== vGutter2) {
                        let itemA1 = vGutter1.itemA;
                        let itemB1 = vGutter1.itemB;
            
                        if (itemA1.x + itemA1.width <= itemA2.x + itemA2.width 
                            && itemB1.x >= itemB2.x
                            && itemA1.y + itemA1.height <= itemA2.y + itemA2.height 
                            && itemB1.y >= itemB2.y
                        ) {


                            let k = verticalGutterAlignments.indexOf(alignment2);
                            if (k !== -1) {
                                // verticalGutterAlignments[k] = undefined;
                                // delete(verticalGutterAlignments[k]);
                                verticalGutterAlignments.splice(k, 1)
                                // console.log('XXX', vGutter2.itemA.id, vGutter2.itemB.id, '@', k, 'bc', vGutter1.itemA.id, vGutter1.itemB.id);
                                vGutter2 = undefined;
                                if (k < j) {
                                    j++
                                }
                            }
                            

                            // delete(candidateHorizontalGutters[j]);// = null;
                        }
                    }
                }
            }
            // console.log(itemA2.id, itemB2.id)
        }




        // console.log('verticalGutterAlignments len', verticalGutterAlignments.length, 'src', sourceItem.id);
        // if ( verticalGutterAlignments.length < 4) {
        //     console.log('verticalGutterAlignments', verticalGutterAlignments);
        // }
            
        if (minAbsoluteVerticalGutterDist < Number.POSITIVE_INFINITY) {
            alignments = alignments.concat(verticalGutterAlignments);
        }
    








    }

    return alignments;
}

export default { getAlignments }



/*

GUTTER-finding notes

    behavioral filter options (modifier keys, preferences, etc) :
    * none (allow all, including fully occluded)

    future work
        * "line of sight" ???
            allow as long as there exists at least one zero-height, uninterrupted line

        * coarse
            no additional object within the gutter rectangle
            /less/ restrictive of 
                - source object as range
                - target objects as range

        * fine ???
            /more/ restrictive of above






*/